// ---- Last-interest helpers ---------------------------------------------------
const LAST_INTEREST_KEY = 'zahs:last-interest';
export function recordInterest(program, track, source) {
  if (!program) return;
  const payload = {
    program: String(program),
    track: track ? String(track) : '',
    source: source || (location.pathname + location.search),
    ts: Date.now()
  };
  try { localStorage.setItem(LAST_INTEREST_KEY, JSON.stringify(payload)); } catch {}
}
function readLastInterest(maxAgeDays = 60) {
  try {
    const raw = localStorage.getItem(LAST_INTEREST_KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || !obj.program) return null;
    const tooOld = maxAgeDays && (Date.now() - (obj.ts || 0)) > maxAgeDays*24*60*60*1000;
    return tooOld ? null : obj;
  } catch { return null; }
}
// -----------------------------------------------------------------------------

export function initZahsLastInterest() {
  enrollNowButtons = document.querySelectorAll('.enroll-btn');
  if (enrollNowButtons) {
    enrollNowButtons.forEach(btn => {
      const program = btn.getAttribute('data-program') || '';
      const track   = btn.getAttribute('data-track') || '';
      if (program) recordInterest(program, track, location.pathname);
    });
  }
}

export function readLastInterest(maxAgeDays = 60) {
  try {
    const raw = localStorage.getItem('zahs:last-interest');
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || !obj.program) return null;
    const tooOld = maxAgeDays && (Date.now() - (obj.ts || 0)) > maxAgeDays*24*60*60*1000;
    return tooOld ? null : obj;
  } catch { return null; }
}

export function applyProgramTrackPrefill() {
  const params  = new URLSearchParams(window.location.search);
  let programId = params.get('program_interest') || '';
  let trackId   = params.get('track_interest')   || '';

  if (!programId) {
    const last = readLastInterest(60);
    if (last) {
      programId = last.program || programId;
      trackId   = last.track   || trackId;
    }
  }

  const progSel  = document.getElementById('program_interest');
  const trackSel = document.getElementById('track_interest');
  if (!progSel || !trackSel) return;

  if (programId) {
    progSel.value = programId;
    // trigger population of tracks for this program
    progSel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (trackId) {
    // assign track after tracks are populated by the change-handler
    const trySet = () => {
      const hasOption = Array.from(trackSel.options).some(o => o.value === trackId);
      if (hasOption) {
        trackSel.value = trackId;
        trackSel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    // attempt now and on the next tick
    trySet();
    setTimeout(trySet, 0);
  }
}